import { FormGroup } from '@angular/forms';
import {
    ApplyBookingResponseDto,
    PartyDetailDto,
} from '@opb-workspace/shared';
import { partyDetailToContactFormPatch } from './step2-party-contact-patch.util';

export function syncPartiesFromApplyBooking(
    form: FormGroup,
    applied: ApplyBookingResponseDto,
    options?: { omitShipper?: boolean },
): {
    shipper: PartyDetailDto | null;
    consignee: PartyDetailDto | null;
    notify: PartyDetailDto | null;
} {
    const omitShipper = !!options?.omitShipper;
    const out = {
        shipper: null as PartyDetailDto | null,
        consignee: null as PartyDetailDto | null,
        notify: null as PartyDetailDto | null,
    };

    if (omitShipper) {
        form.patchValue(
            {
                shipperPartyId: null,
                shipperName: '',
                shipperAddress: '',
                shipperEmail: '',
                shipperTaxIdentificationNumber: '',
                shipperContactName: '',
                shipperPhoneNumber: '',
                shipperMobilePhoneNumber: '',
            },
            { emitEvent: false },
        );
    }

    form.patchValue({
        customerContactEmail: applied.customerContactEmail,
        customerAttentionContactName: applied.customerAttentionContactName,
        customerTaxIdentificationNumber: applied.customerTaxIdentificationNumber,
    });

    if (applied.shipper && !omitShipper) {
        out.shipper = applied.shipper;
        form.patchValue({
            shipperPartyId: applied.shipper.partyId,
            shipperName: applied.shipper.name,
            shipperAddress: applied.shipper.address,
            ...partyDetailToContactFormPatch('shipper', applied.shipper),
        });
    }
    return out;
}
